import React, { useState } from 'react';
import { Link as GatsbyLink } from 'gatsby';
import { AppBar, Toolbar, Typography, Link, Button, Tooltip } from '@material-ui/core';
import { Theme, makeStyles } from '@material-ui/core/styles';
import { BsToggleOn, BsToggleOff } from 'react-icons/bs';
import FacebookIcon from '@mui/icons-material/Facebook';

import { FC } from '../../util';

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.text.primary,
        position: 'fixed'
    },
    title: {
        flexGrow: 15,
        width: '50%',
        [theme.breakpoints.down('md')]: {
            width: '20%'
        }
    },
    link: {
        textDecoration: 'none',
        flexGrow: 1,
        [theme.breakpoints.down('md')]: {
            flexGrow: 3
        }
    },
    toolbar: {
        justifyContent: 'space-around'
    },
    logo: {
        maxWidth: '50%'
    }
}));

export interface HeaderProps {
    switchTheme: () => void;
    siteTitle?: string;
}

const Header: FC<HeaderProps> = (props) => {
    const [showOn, setShowOn] = useState<boolean>(false);
    const styles = useStyles();

    const onSwitch = (): void => {
        setShowOn((prev) => !prev);
        props.switchTheme();
    };

    return (
        <AppBar component="header" position="static" className={styles.root}>
            <Toolbar className={styles.toolbar}>
                <Typography variant="h6" className={styles.title}>
                    <Link to="/" component={GatsbyLink} color="inherit" className={styles.link}>
                        <img className={styles.logo} src="/sls_logo.png"></img>
                    </Link>
                </Typography>
                <Link to="/about/" component={GatsbyLink} color="inherit" className={styles.link}>
                    About
                </Link>
                <Link
                    to="/products/"
                    component={GatsbyLink}
                    color="inherit"
                    className={styles.link}
                >
                    Products
                </Link>
                <Link to="/find-us/" component={GatsbyLink} color="inherit" className={styles.link}>
                    Find us
                </Link>
                <Link href="https://www.facebook.com/SLSwater" className={styles.link}>
                    <FacebookIcon />
                </Link>
            </Toolbar>
        </AppBar>
    );
};

export default Header;
